import {CopyPasteConnectorData} from 'src/app/shared/models/copy-paste-connector-data.interface';
import {ConnectorLinkData} from 'src/app/shared/models/connector-link.interface';

const DE_CONNECTOR_LINK_CACHE = 'de-connector-link-cache';

const DEFAULT_CONNECTOR_ERROR = 'CONNECTOR.ERROR_UNEXPECTED';

const EMPTY_LINK: ConnectorLinkData = {
  diagramVersion: {
    id: '',
    title: '',
    mapName: '',
    diagramId: '',
    levelNumber: null,
    spaceId: ''
  },
  connector: {id: ''},
  flowline: {id: ''}
};
const EMPTY_BUFFER: CopyPasteConnectorData = {
  user: {},
  link: EMPTY_LINK
};

const CONNECTOR_ERROR_TRANSLATIONS = {
  'fl.connection.exists': 'CONNECTOR.ERROR_ALREADY_EXISTS',
  'connection.team.not.the.same': 'CONNECTOR.TEAM_NOT_THE_SAME',
  'connector_link.empty_cache': 'connector_link.empty_cache',
  'connector_link.invalid_flowline_target': 'CONNECTOR.INVALID_FLOWLINE_TARGET',
  'map.err.rights.does_not_exist': 'CONNECTOR.NO_MAP_ACCESS',
  'flca.err.source.target_type.connector': 'CONNECTOR.SOURCE_CONN_NOT_FOUND',
  'flca.not_found.source': 'CONNECTOR.SOURCE_NOT_FOUND',
  'flca.err.target.source_type.connector': 'CONNECTOR.TARGET_CONN_NOT_FOUND',
  'flca.not_found.target': 'CONNECTOR.TARGET_NOT_FOUND',
  'flca.err.same_diagram': 'CONNECTOR.SAME_TARGET_DIAGRAM',
  'connector_link.same_target_diagram': 'CONNECTOR.SAME_TARGET_DIAGRAM'
} as const;

type ConnectorError = keyof typeof CONNECTOR_ERROR_TRANSLATIONS;

export {
  CONNECTOR_ERROR_TRANSLATIONS,
  ConnectorError,
  DE_CONNECTOR_LINK_CACHE,
  DEFAULT_CONNECTOR_ERROR,
  EMPTY_BUFFER,
  EMPTY_LINK
};
